module.exports = __webpack_public_path__ + "static/media/monetization-icon.a202a019.svg";